import { formatPhoneNumber, useCreateEmailContact } from '@application/utils';
import type { WhatsappModalFormValues } from '@presentation/components';
import { useCallback } from 'react';
import { EmailContactCreatedFromEnum } from '@gql/graphql';

export const useSaveEmailContact = () => {
  const { createEmailContactFromForm, createEmailContactLoading, createEmailContactError } =
    useCreateEmailContact({ shouldShowToast: false });

  const createEmailContact = useCallback(
    (values: WhatsappModalFormValues, resource: 'pro' | 'breeder') => {
      const phone = formatPhoneNumber(values.phone, values.phonePrefixCountry);

      const createdFrom =
        resource === 'breeder'
          ? EmailContactCreatedFromEnum.WHATSAPP_BREEDER
          : EmailContactCreatedFromEnum.WHATSAPP_GROOMER;
      return createEmailContactFromForm({
        createdFrom,
        email: values.email,
        firstName: values.firstName,
        lastName: values.lastName,
        marketingEmailConsent: true,
        phone,
      })
        .then(() => {})
        .catch((err) => console.log(err));
    },
    [createEmailContactFromForm],
  );

  return { createEmailContact, createEmailContactLoading, createEmailContactError };
};
